import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';

import AmenityForm from '@/components/forms/AmenityForm';
import FormWrapper from '@/components/forms/FormWrapper';
import { AmenityData } from '@/lib/validations/AmenitiesSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateAmenity = () => {
  const { amenityDataJson, amenityIndex } = useLocalSearchParams<{ amenityDataJson: string; amenityIndex: string }>();
  const [initialAmenityData, setinitialAmenityData] = useState<AmenityData | undefined>(undefined);

  useEffect(() => {
    if (amenityDataJson) {
      const parsedProgram = safeJsonParse<AmenityData>(amenityDataJson);
      if (parsedProgram) setinitialAmenityData(parsedProgram);
    }
  }, [amenityDataJson]);

  return (
    <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
      <AmenityForm
        initialData={initialAmenityData}
        showDoneButton
        onDone={(data) => {
          router.navigate({
            pathname: '/create/amenities',
            params: {
              amenityDataJson: JSON.stringify(data),
              amenityIndex: amenityIndex
            }
          });
        }}
      />
    </FormWrapper>
  );
};

export default AddUpdateAmenity;
